import { useEffect } from 'react';
import { useNotificationStore } from '@/store/notificationStore';
import { useCurrentUser, useSessionStatus } from '@/store/sessionStore';

/**
 * Cuántas notificaciones sin leer hay, para el punto rojo del menú.
 *
 * Cuenta una sola vez por sesión y sólo con sesión iniciada. Devuelve
 * `refresh` para volver a contar después de marcar algo como leído: sin eso,
 * el punto seguiría encendido sobre notificaciones ya vistas, que es la forma
 * más rápida de que la gente deje de mirarlo.
 */
export function useUnreadNotifications(): { unread: number; refresh: () => Promise<void> } {
  const user = useCurrentUser();
  const status = useSessionStatus();
  const { unread, loaded, refresh } = useNotificationStore();

  const uid = user?.uid ?? null;

  useEffect(() => {
    if (status === 'ready' && uid && !loaded) void refresh(uid);
  }, [status, uid, loaded, refresh]);

  return { unread: uid ? unread : 0, refresh: () => refresh(uid) };
}
